"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impactShopUnitTypeMapping = exports.impactShopProductUnitTypePluralMapper = exports.createImpactShopBasketProduct = exports.areImpactShopBasketProductsEqual = void 0;
const impact_1 = require("../impact");
const utils_1 = require("../utils");
const areImpactShopBasketProductsEqual = (productA, productB) => productA.id === productB.id && (0, utils_1.normaliseString)(productA.fundedBy) === (0, utils_1.normaliseString)(productB.fundedBy);
exports.areImpactShopBasketProductsEqual = areImpactShopBasketProductsEqual;
const createImpactShopBasketProduct = (product, quantity, fundedBy) => ({
    id: product.id,
    display: product.display,
    fundedBy: fundedBy,
    minQuantity: product.minQuantity,
    maxQuantity: product.maxQuantity,
    quantity: quantity,
    prices: product.prices,
});
exports.createImpactShopBasketProduct = createImpactShopBasketProduct;
exports.impactShopProductUnitTypePluralMapper = {
    tree: 'trees',
    'tonne CO2e': 'tonnes CO2e',
    kg: 'kg',
    m2: 'squared meters',
};
/**
 * Converts from Impact Shop unit into ImpactUnit
 */
exports.impactShopUnitTypeMapping = {
    'tonne CO2e': 'tonnes',
    kg: 'kilograms',
    tree: null,
    m2: 'm2',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1wYWN0LXNob3AtcHJvZHVjdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pbXBhY3Qtc2hvcC9pbXBhY3Qtc2hvcC1wcm9kdWN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLHNDQUF1QztBQUd2QyxvQ0FBMkM7QUFFcEMsTUFBTSxnQ0FBZ0MsR0FBRyxDQUM5QyxRQUFpQyxFQUNqQyxRQUFpQyxFQUNqQyxFQUFFLENBQUMsUUFBUSxDQUFDLEVBQUUsS0FBSyxRQUFRLENBQUMsRUFBRSxJQUFJLElBQUEsdUJBQWUsRUFBQyxRQUFRLENBQUMsUUFBUSxDQUFDLEtBQUssSUFBQSx1QkFBZSxFQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUhqRyxRQUFBLGdDQUFnQyxvQ0FHaUU7QUFFdkcsTUFBTSw2QkFBNkIsR0FBRyxDQUMzQyxPQUE4QixFQUM5QixRQUFnQixFQUNoQixRQUFnQixFQUNTLEVBQUUsQ0FBQyxDQUFDO0lBQzdCLEVBQUUsRUFBRSxPQUFPLENBQUMsRUFBRTtJQUNkLE9BQU8sRUFBRSxPQUFPLENBQUMsT0FBTztJQUN4QixRQUFRLEVBQUUsUUFBUTtJQUNsQixXQUFXLEVBQUUsT0FBTyxDQUFDLFdBQVc7SUFDaEMsV0FBVyxFQUFFLE9BQU8sQ0FBQyxXQUFXO0lBQ2hDLFFBQVEsRUFBRSxRQUFRO0lBQ2xCLE1BQU0sRUFBRSxPQUFPLENBQUMsTUFBTTtDQUN2QixDQUFDLENBQUM7QUFaVSxRQUFBLDZCQUE2QixpQ0FZdkM7QUF5QlUsUUFBQSxxQ0FBcUMsR0FDaEQ7SUFDRSxJQUFJLEVBQUUsT0FBTztJQUNiLFlBQVksRUFBRSxhQUFhO0lBQzNCLEVBQUUsRUFBRSxJQUFJO0lBQ1IsRUFBRSxFQUFFLGdCQUFnQjtDQUNyQixDQUFDO0FBRUo7O0dBRUc7QUFDVSxRQUFBLHlCQUF5QixHQUFHO0lBQ3ZDLFlBQVksRUFBRSxRQUFpQjtJQUMvQixFQUFFLEVBQUUsV0FBb0I7SUFDeEIsSUFBSSxFQUFFLElBQUk7SUFDVixFQUFFLEVBQUUsSUFBYTtDQUNzQyxDQUFDIn0=